export default function isPriorityMessage({ FolderId, IsTopMatch, Message }) {
  return FolderId !== 0 && IsTopMatch && Message !== 'Catch All';
}
